import ReusableDataTable from "src/components/table/ReusableDataTable";
import { mapDistrictToDataTable as mapData, isSelect } from "./Helper";
import GetDistrictColumns from "./ColumnDefinition/DistrictColumn/GetDistrictColumns";

const DistrictTable = ({
  data,
  handleDelete,
  handleOpenPopup,
  status,
  districtId,
  setDistrictId,
}) => {
  const columns = GetDistrictColumns({
    handleDelete,
    handleOpenPopup,
    status,
  });

  return (
    <ReusableDataTable
      columns={columns}
      data={mapData(data, districtId)}
      maxHeight={450}
      getRowStyle={(item) => isSelect(districtId, item)}
      onRowClick={(item) => setDistrictId(item.id)}
    />
  );
};

export default DistrictTable;
